import { EntityNames } from "../../../enums/EntityNames";
import { EntityViewTypes } from "../../../enums/EntityViewTypes";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../modules/auth/Permissions/PermissionStrings";
import List from "../List/List";
import Layout from "../layout/Layout";
import { RouteComponentProps } from "@reach/router";

export default function CustomersPage(props: RouteComponentProps) {
    const { permissions } = usePermissions();
    const canView = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Customers);
    const canAddCustomer = hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Customer_Accounts);
    const canAddAccount = hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Add_Account);
    return (
        <Layout pageTitle="Customers" showBackButton={false} showBreadcrumb={false} canScroll={false}>
            <List parentEntityName={undefined}
                entityId={''}
                entityName={EntityNames.customers}
                enableFilters={true}
                searchType={EntityViewTypes.search}
                canAdd={canView && canAddCustomer && canAddAccount}
                tabView={false} />
        </Layout>
    )
}